import { Environment } from '@1debit/device-intelligence';

const isDevEnvironment = process.env.DEPLOYMENT_ENVIRONMENT === 'dev';
const isProdEnvironment = process.env.DEPLOYMENT_ENVIRONMENT === 'prod';

export const deviceIntelligenceEnvironment = isDevEnvironment
  ? Environment.Development
  : isProdEnvironment
    ? Environment.Production
    : Environment.NonProduction;
